/* eslint-disable jira/filename-case */
export type ConnectionFieldIssueTypeFilter = {
	type: 'name';
	/**
	 * The issue type names to filter by.
	 * For now we support selecting only one issue type name, so we always select the first item in the array.
	 */
	names: string[];
	projectIds: string[];
};

export const isIssueTypeNameFilter = (
	filter: ConnectionFieldIssueTypeFilter,
): filter is ConnectionFieldIssueTypeFilter => filter.type === 'name';

export type ConnectionFieldIssueViewLayoutSort = {
	fieldKey: string;
	order: 'ASC' | 'DESC';
};
